const DEFAULT_BREAKPOINT = 768

function initSingleTable(table, breakpoint) {
    const thead = table.querySelector('thead')
    const tbody = table.querySelector('tbody')

    if (!tbody) return

    const originalTheadHTML = thead ? thead.innerHTML : ''
    const originalRows = Array.from(tbody.querySelectorAll('tr'))
    let isMobile = null
    let resizeTimeout = null

    function buildMobileTheadRows() {
        if (!thead) return { base: [], extra: [] }

        const baseRows = []
        const newRows = []

        Array.from(thead.querySelectorAll('tr')).forEach((row) => {
            const ths = row.querySelectorAll('th')
            if (!ths.length) return

            const tds = Array.from(ths).map((th) => {
                const td = document.createElement('td')
                td.innerHTML = th.innerHTML
                td.className = th.className
                return td
            })

            const timeTd = tds[0]
            const hasThirdColumn = tds[2] && tds[2].textContent.trim()

            const baseRow = document.createElement('tr')
            tds.forEach((td, i) => {
                if (i !== 2) baseRow.appendChild(td.cloneNode(true))
            })
            baseRows.push(baseRow)

            if (hasThirdColumn) {
                const newRow = document.createElement('tr')
                newRow.appendChild(timeTd.cloneNode(true))
                newRow.appendChild(tds[2].cloneNode(true))
                newRows.push(newRow)
            }
        })

        return { base: baseRows, extra: newRows }
    }

    function buildMobile() {
        const fragment = document.createDocumentFragment()

        const baseRows = []
        const newRows = []

        const { base: theadBase, extra: theadExtra } = buildMobileTheadRows()
        theadBase.forEach((r) => fragment.appendChild(r))

        originalRows.forEach((row) => {
            const tds = row.querySelectorAll('td')
            const timeTd = tds[0]
            const hasThirdColumn = tds[2] && tds[2].textContent.trim()

            const baseRow = row.cloneNode(true)
            baseRow.querySelectorAll('td')[2]?.remove()
            baseRows.push(baseRow)

            if (hasThirdColumn) {
                const newRow = document.createElement('tr')
                newRow.appendChild(timeTd.cloneNode(true))
                newRow.appendChild(tds[2].cloneNode(true))
                newRows.push(newRow)
            }
        })

        baseRows.forEach((r) => fragment.appendChild(r))
        theadExtra.forEach((r) => fragment.appendChild(r))
        newRows.forEach((r) => fragment.appendChild(r))

        if (thead) thead.innerHTML = ''
        tbody.innerHTML = ''
        tbody.appendChild(fragment)
    }

    function restoreDesktop() {
        if (thead) thead.innerHTML = originalTheadHTML

        tbody.innerHTML = ''
        originalRows.forEach((row) => {
            tbody.appendChild(row.cloneNode(true))
        })
    }

    function updateLayout() {
        const shouldBeMobile = window.innerWidth < breakpoint

        if (shouldBeMobile === isMobile) return

        isMobile = shouldBeMobile

        if (isMobile) {
            buildMobile()
        } else {
            restoreDesktop()
        }
    }

    function onResize() {
        clearTimeout(resizeTimeout)
        resizeTimeout = setTimeout(updateLayout, 150)
    }

    updateLayout()
    window.addEventListener('resize', onResize)
}

export function initTableResponsive({
    selector = '.render-context-program',
    breakpoint = DEFAULT_BREAKPOINT,
} = {}) {
    document.querySelectorAll(selector).forEach((table) => {
        initSingleTable(table, breakpoint)
    })
}
